import React from 'react'
import { RegisterHeader } from '../../Components/Index'
import Footer from '../../../../Layout/Footer'
// import { Footer } from 'antd/lib/layout/layout'

const Guidline = () => {
  return (
    <React.Fragment>
    <RegisterHeader/>
      <div className="py-5 px-2 container  d-flex align-items-center">
        <div className="container">
            <div className="card mt-5">
                <div className="card-body px-5">
                    <h2 className="instruction-head text-center my-2 py-4">APPLICATION GUIDELINES FOR RECRUITMENT INTO NIGERIA POLICE FORCE <br/> FOR SPECIALIST (ARTISAN) & GENERAL DUTY CONSTABLES</h2>
                    <p style={{ color: '#000', fontSize: 14 }}> The Police Service Commission (PSC) in conjunction with the Nigeria Police Force(NPF) invites applications from
                        interested and qualified Nigerians for enlistment into the Nigeria Police Force as Specialist (Artisan) & General Duty Police Constable (Recruits).
                    </p>
                    <p style={{ color: '#000', fontSize: 14 }}>The online application portal will
                        be opened for the period of six weeks from 15th December 2025 to 25th January 2026, where prospective applicants are required to complete the
                        online application forms and submitted within the specified period via this portal
                        The portal is open to both male and female Nigerians of good character.
                    </p>
                    <p style={{ color: '#000', fontSize: 14 }}>
                        Successful Applicants will undergo a combined Academic and Physical Training leading to the employment of successful ones into the
                        Nigeria Police Force as Specialist (Artisan) Police Constables (PC).
                    </p>
                    <p style={{ color: '#000', fontSize: 14, fontWeight: "bold" }}>
                        THE RECRUITMENT EXERCISE IS FREE OF CHARGE
                    </p>
                    <b style={{ color: '#005bb9' }}> GENERAL REQUIREMENT / METHOD OF APPLICATION </b>
                    <div>
                        <ol>
                            <li>Applicants shall be of Nigerian origin by birth</li>
                            <li>Applicants MUST have their National Identification Number (NIN), a Functional Email address and valid phone number before they commence the application.</li>
                            <li>Applicants are required to upload scanned copies of their SSCE, Birth and Certificates of Origin</li>
                            <li>Must be free from financial embarrassment</li>
                            <li>Must be of good character</li>
                            <li>Must not have been convicted of any criminal offence(s) </li>
                            <li>Applicant must have passion for a career in the Nigeria Police Force</li>
                            <li>Applicants must be medically, physically, and psychologically fit</li>
                            <li>General Duty Applicants must not be less than 1.67m in height for males and 1.64m in height for females. In addition, Expanded Chest
                                measurement for General Duty males must not be less than 86cm (34 inches).</li>
                            <li>Female applicants must not be pregnant at the time of entry and throughout the duration of training (if successful);</li>
                            <li>Applicants should be free from conditions such as: Defective eyesight, knock knees, bow legs, bent arms, deformed arms/legs, flat foot, amputation of any part of the body;</li>
                        </ol>
                    </div>
                    <b style={{ color: '#005bb9' }}> GENERAL DUTY CONSTABLE REQUIREMENT </b>
                    <div>
                        <ol>
                            <li>Applicants must possess a minimum of 5 credits in not more than 2 sittings in WASSCE/GCE/NECO with credit passes in English and Mathematics not later than 2018</li>
                            <li>Applicants must be aged between 18-25 years.</li>
                        </ol>
                    </div>
                    <b style={{ color: '#005bb9' }}> SPECIALIST (ARTISAN) CONSTABLE REQUIREMENT </b>
                    <div>
                        <ol>
                            <li>Applicants must possess a minimum of 4 credits in not more than 2 sittings in WASSCE/GCE/NECO or its equivalent with credit passes in English and Mathematics not later than 2015</li>
                            <li>Applicants must be aged between 18-28 years.</li>
                            <li>Medical Assistants must possess a minimum of 5 credits in not more than 2 sittings in WASSCE/SSCE or its equivalent with credit passes in English and Mathematics while other Certificates in relevant fields will be added advantage</li>
                            <li>Other Specialized Fields
                                <ul>
                                    <li>Medical Assistant (MEDICAL)</li>
                                    <li>Driver (proven driving skills/ Drivers Licence - TRANSPORT)</li>
                                    <li>Mechanic (TRANSPORT)</li>
                                    <li>Auto-Electrician (TRANSPORT)</li>
                                    <li>Driver/Mechanic (TRANSPORT)</li>
                                    <li>Dispatch and Escort Riders (TRANSPORT)</li>
                                    <li>Forensic Assistant/Robotic & Drone (EOD-CBRN) </li>
                                    <li>General EOD-CBRN Operative (EOD-CBRN)</li>
                                    <li>Admin/Analytical & Welfare Support (EOD-CBRN)</li>
                                    <li>Dog handler (K9)</li>
                                    <li>Horse Riders (MOUNTED TROOP)</li>
                                    <li>Deckhand (Able Seaman)</li>
                                    <li>Launch Quartermaster</li>
                                    <li>Underwater Welder (MARINE)</li>
                                    <li>Electrical/Electronic Technician (MARINE)</li>
                                    <li>Lathe Machine Operator (MARINE)</li>
                                    <li>Diver (MARINE) </li>
                                    <li>Marine Engineer Assistant (MARINE)</li>
                                    <li>Boat Mechanic (MARINE)</li>
                                    <li>Electrician (Including Security Door Experts) </li>
                                    <li>Plumber</li>
                                    <li>Refrigeration/Air Conditioning Technician</li>
                                    <li>Generator Repairer</li>
                                    <li>Welder</li>
                                    <li>Tailors (with proven tailoring skills)</li>
                                    <li>Technician (COMMUNICATION)</li>
                                    <li>Operator (COMMUNICATION)</li>
                                    <li>IT Operator/Technician (ICT)</li>
                                    <li>Musical Equipment (BAND)</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        </div>

      <Footer/>
   </React.Fragment>
  )
}

export default Guidline
